// TransactionDetails.jsx
import React from 'react';
import CardDetails from '../CardDetails';
import PaimentDetail from '../PaimentDetail';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;
const TransactionDetails = ({
  soldeTotal,
  nbrTransactions,
  nbrEntree,
  nbrSortie,
  comptePaiement,
  onCardClick,
}) => (
  <Container>
    <CardDetails
      solde_total={soldeTotal}
      nbrTransactions={nbrTransactions}
      nbrEntree={nbrEntree}
      nbrSortie={nbrSortie}
    />
    <PaimentDetail
      comptePaiement={comptePaiement}
      onCardClick={onCardClick}
    />
  </Container>
);

export default TransactionDetails;
